<div class="row" *ngIf="isDashboard">

  <div *ngIf="!isDataWebsiteUsage">
    <div class="col xl6 s12 m12 l6" *ngIf="ArrFirstlabels.length" style="padding: 0 15px;">
      <div *ngFor="let item of ArrFirstlabels;let index = index" class="row chartLabel">
        <div class="row">
          <div class="row"
            style="margin-bottom: 10px; margin-left: 0; margin-right: 0; display: flex; align-items: center; justify-content: space-between;">
            <div class="col s8" style="padding-left: 0;">
              <div class="app-label" matTooltip="{{item.appName}}">{{item.appName}}</div>
            </div>
            <div class="col s4" style="text-align: right; padding-right: 0;">
              <span class="hours" *ngIf="item.usageTime">{{timeToHours(item.usageTime)}}</span>
            </div>
          </div>
          <div class="row" style="margin-bottom: 0; margin-left: 0; margin-right: 0;">
            <div class="col s12" style="padding: 0;">
              <div id="progress_bar" class="progressDiv addMargin"
                [tooltipDirective]="{ appName: item.appName, star_date: starDate, end_date: endDate, type: 'app'}"
                placement="bottom" delay="200" style="cursor: pointer;">
                <div id="progress_bar"
                  [ngStyle]="{'width': getUsagePercentage(item),'background-color': BarColor1[index],'height': '12px'}"
                  class="addMargin">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col xl6 s12 m12" *ngIf="!ArrFirstlabels.length">
      <div class="row chartLabel">
        <div class="row" style="margin-bottom: 5px;">
          <div class="col s12 app-label">No used application</div>
        </div>
        <div class="row" style="margin-bottom: 0;">
          <div class="col s12">
            <div class="progressDiv addMargin">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col xl6 s12 m12 l6" style="padding: 0 15px;">
      <div *ngFor="let item of ArrSecondlabels;let index = index" class="row chartLabel">
        <div class="row">
          <div class="row"
            style="margin-bottom: 8px; display: flex; align-items: center; justify-content: space-between;">
            <div class="col s8" style="padding-left: 0;">
              <div class="app-label" matTooltip="{{item.appName}}">{{item.appName}}</div>
            </div>
            <div class="col s4" style="text-align: right; padding-right: 0;">
              <span class="hours" *ngIf="item.usageTime">{{timeToHours(item.usageTime)}}</span>
            </div>
          </div>
          <div class="row" style="margin-bottom: 0;">
            <div class="col s12">
              <div class="progressDiv addMargin" id="progress_bar"
                [tooltipDirective]="{ appName: item.appName, star_date: starDate, end_date: endDate, type: 'app'}"
                placement="bottom" delay="200" style="cursor: pointer;">
                <div id="progress_bar"
                  [ngStyle]="{'width': getUsagePercentage(item),'background-color': BarColor2[index],'height': '12px'}"
                  class="addMargin">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isDataWebsiteUsage">
    <div class="col s12 m12 l6 extraLarge6" *ngIf="ArrFirstLabelsWebsiteUsageChart.length" style="padding: 0 15px;">
      <div *ngFor="let item of ArrFirstLabelsWebsiteUsageChart;let index = index" class="row chartLabel">
        <div class="row">
          <div class="row"
            style="margin-bottom: 8px; display: flex; align-items: center; justify-content: space-between;">
            <div class="col s8" style="padding-left: 0;">
              <div class="app-label" matTooltip="{{item.appName}}">{{item.appName}}</div>
            </div>
            <div class="col s4" style="text-align: right; padding-right: 0;">
              <span class="hours" *ngIf="item.usageTime">{{timeToHours(item.usageTime)}}</span>
            </div>
          </div>
          <div class="row" style="margin-bottom: 0;">
            <div class="col s12">
              <div id="progress_bar" class="progressDiv addMargin"
                [tooltipDirective]="{ appName: item.appName,star_date:starDateWebsiteUsage,end_date:endDateWebsiteUsage, type: 'website'}"
                placement="bottom" delay="200" style="cursor: pointer;">
                <div id="progress_bar"
                  [ngStyle]="{'width': getUsagePercentage(item),'background-color': BarColor1[index],'height': '12px'}"
                  class="addMargin">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col s12 m6" *ngIf="!ArrFirstLabelsWebsiteUsageChart.length">
      <div class="row chartLabel">
        <div class="row" style="margin-bottom: 5px;">
          <div class="col s12 app-label">No Website Usage</div>
        </div>
        <div class="row" style="margin-bottom: 0;">
          <div class="col s12">
            <div class="progressDiv addMargin">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col s12 m12 l6 extraLarge6" style="padding: 0 15px;">
      <div *ngFor="let item of ArrSecondLabelsWebsiteUsageChart;let index = index" class="row chartLabel">
        <div class="row">
          <div class="row"
            style="margin-bottom: 8px; display: flex; align-items: center; justify-content: space-between;">
            <div class="col s8" style="padding-left: 0;">
              <div class="app-label" matTooltip="{{item.appName}}">{{item.appName}}</div>
            </div>
            <div class="col s4" style="text-align: right; padding-right: 0;">
              <span class="hours" *ngIf="item.usageTime">{{timeToHours(item.usageTime)}}</span>
            </div>
          </div>
          <div class="row" style="margin-bottom: 0;">
            <div class="col s12">
              <div id="progress_bar" class="progressDiv addMargin"
                [tooltipDirective]="{ appName: item.appName,star_date:starDateWebsiteUsage,end_date:endDateWebsiteUsage, type: 'website'}"
                placement="bottom" delay="200" style="cursor: pointer;">
                <div id="progress_bar"
                  [ngStyle]="{'width': getUsagePercentage(item),'background-color': BarColor2[index],'height': '12px'}"
                  class="addMargin">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row chart-label-container" *ngIf="!isDashboard" style="width: 100%;">
  <!-- FOR WEBSITE USAGE PROGRESS BARS -->
  <div *ngIf="isDataWebsiteUsage">
    <div class="col xl12 s12 m12" *ngIf="displayForWebsiteUsageChart.length">
      <div [ngClass]="{'pieChart-lables': gridTemplate}">
        <div class="website-usage-list"
          [ngStyle]="{ 'flex-direction': displayForWebsiteUsageChart.length <= listShowingLength ? 'column' : 'row' }">
          <ng-container *ngIf="displayForWebsiteUsageChart.length > listShowingLength; else fullList">
            <div class="website-usage-col">
              <ng-container
                *ngTemplateOutlet="usageItems; context: { items: displayForWebsiteUsageChart | slice: 0 : listShowingLength, colorOffset: 0 }"></ng-container>
            </div>
            <div class="website-usage-col">
              <ng-container
                *ngTemplateOutlet="usageItems; context: { items: displayForWebsiteUsageChart | slice: listShowingLength : displayForWebsiteUsageChart.length, colorOffset: listShowingLength }"></ng-container>
            </div>
          </ng-container>
          <ng-template #fullList>
            <ng-container
              *ngTemplateOutlet="usageItems; context: { items: displayForWebsiteUsageChart, colorOffset: 0 }"></ng-container>
          </ng-template>
          <ng-template #usageItems let-items="items" let-colorOffset="colorOffset">
            <div *ngFor="let item of items; let index = index"
              [ngClass]="{'chartLabelsForGrid': gridTemplate, 'chartLabelVal': !gridTemplate}">
              <div class="row chart-label-contain">
                <div class="col s10 chart-label-dot-contain">
                  <div class="chart-label-dot" [ngStyle]="getDotStyle(index + colorOffset)"></div>
                  <div class="app-name" matTooltip="{{item.appName}}" [ngStyle]="{'color': BarColor[index + colorOffset]}">
                    {{ item.appName }}
                  </div>
                </div>
                <div class="col s2 hours" *ngIf="item.usageTime">
                  {{ timeToHours(item.usageTime) }}
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="col s12" *ngIf="!displayForWebsiteUsageChart.length">
      <div class="row chartLabelVal no-data-found-msg">
        <div class="col s2 ml-0">
          <div
            [ngStyle]="{'width': '20px','background-color':' #f1f1f4','height': '20px','text-align': 'end','border-radius': '50%', 'float': 'right'}">
          </div>
        </div>
        <div class="col ml-0 s7" style="color: #8B8BA7;">No Website Usage</div>
      </div>
    </div>
  </div>
  <!-- FOR WEBSITE USAGE PROGRESS BARS SCOPE ENDS -->

  <div *ngIf="!isDataWebsiteUsage">
    <div class="col xl12 s12 m12" *ngIf="display.length">
      <div [ngClass]="{'pieChart-lables': gridTemplate , 'app-usage-labels': true}">
        <div *ngFor="let item of display;let index = index"
          [ngClass]="{'chartLabelsForGrid': gridTemplate, 'chartLabelVal' : !gridTemplate}"
          [style.width]="'calc(100% / '+ grid +')'">
          <div class="row chart-label-contain">
            <div class="col s10  chart-label-dot-contain">
              <div
                [ngStyle]="{'width': '14px','background-color': BarColor[index],'height': '14px','text-align': 'end','border-radius':'50%'}">
              </div>
              <div class="app-name" matTooltip="{{item.appName}}" [ngStyle]="{'color':BarColor[index]}">
                {{item.appName}}
              </div>
            </div>
            <div class="col s2 hours" *ngIf="item.usageTime">
              {{timeToHours(item.usageTime)}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col s12" *ngIf="!display.length">
      <div class="row chartLabelVal">
        <div class="col s2 ml-0">
          <div
            [ngStyle]="{'width': '20px','background-color':' #f1f1f4','height': '20px','text-align': 'end','border-radius':'50%', 'float': 'right'}">
          </div>
        </div>
        <div class="col s7 ml-0" style="color: #8B8BA7;">No used application</div>
      </div>
    </div>
  </div>
</div>